import { AiFillEdit } from 'react-icons/ai';
import { Link, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Switch from "react-switch";

import { FormField } from '../../../../components/FormField';
import { useEditStore } from '../../../../network';

export const StoresList = ({ stores = [] }) => {
    const { t } = useTranslation();

    const searchParams = new URLSearchParams(location.search);
    const search = searchParams.get('search');

    const { mutate: editStore, isLoading: isEditStore } = useEditStore();

    const filteredStores = search ? stores.filter((store) => store.name.toLowerCase().includes(search.toLowerCase())) : stores;

    const { url } = useRouteMatch();
    return (
        <div className="flex flex-col">
            <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                    <table className="min-w-full " style={{ borderSpacing: '0 12px' }}>
                        <thead>
                            <tr>
                                <th scope="col" className="pl-4 py-3 text-sm font-bold text-left">
                                    {t('Name')}
                                </th>
                                <th scope="col" className="py-3 text-sm font-bold text-left">
                                    {t('Address')}
                                </th>
                                <th scope="col" className="py-3 text-sm font-bold text-left">
                                    {t('Open/Close')}
                                </th>
                                <th scope="col" className="py-3 text-sm font-bold text-left">
                                    <span className="sr-only">{t('Edit')}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredStores.map((store) => {
                                const { address, name, is_open, id } = store;
                                return (
                                    <tr key={id} className="rounded-lg bg-white py-4 border-b">
                                        <td className="w-1/3 whitespace-nowrap pl-4 py-4 text-sm font-medium text-gray-900">
                                            <Link to={`${url}/${id}`} className="inline-flex items-center text-indigo-600 hover:text-indigo-900">
                                                {name}
                                            </Link>
                                        </td>
                                        <td className="whitespace-nowrap lg:whitespace-normal py-4 text-sm text-gray-500">{address}</td>
                                        <td className="whitespace-nowrap py-4 text-sm text-gray-500">
                                            <FormField
                                                disabled
                                                popoverText="On development stage"
                                                popoverStyle={{
                                                    left: -40,
                                                    minWidth: 200,
                                                    maxWidth: 200,
                                                    bottom: 40,
                                                }}
                                            >
                                                <Switch
                                                    onChange={() =>
                                                        editStore({
                                                            id,
                                                            params: { ...store, is_open: !is_open },
                                                        })
                                                    }
                                                    checked={is_open}
                                                    disabled={isEditStore}
                                                    onColor="#7f56d9"
                                                    offColor="#e5e7eb"
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                    height={24}
                                                    width={44}
                                                />
                                            </FormField>
                                        </td>
                                        <td className="relative whitespace-nowrap py-4 pr-4 text-center text-sm font-medium">
                                            <Link to={`${url}/${id}`} className="inline-flex items-center text-indigo-600 hover:text-indigo-900">
                                                <AiFillEdit size={20} />
                                            </Link>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
